export function createDeliveryOptionsServiceGetter(locale, httpClient, controllerConfig, errorHandler) {
  let serviceInstance = null;
  return async () => {
    if (!serviceInstance) {
      const {
        DeliveryOptionsService
      } = await import('@wix/delivery-section-checkout/services');
      serviceInstance = new DeliveryOptionsService({
        locale,
        httpClient,
        timezone: controllerConfig.wixCodeApi.site.timezone,
        experiments: controllerConfig.essentials.experiments,
        errorHandler
      });
    }
    return serviceInstance;
  };
}
//# sourceMappingURL=deliveryOptionsGetter.js.map